<template>
  <div class="box_wrapper">
    <div>
      <div  style="text-align:right;padding-right:20px;cursor:pointer"  >
        <i @click="delist(listLiData.index,listLiData.id)" class="el-icon-delete" style="font-size:24px;" ></i></div>
<!--      <el-form-item label="标题" prop="title" >-->
<!--        <el-input style="width:500px;" v-model="listLiData.title" placeholder="标题"></el-input>-->
<!--      </el-form-item>-->
    </div>
    <div class="border" style="display:flex;justify-content: space-between;">
      <div>
        用户在
        <el-date-picker
          prop="startTime"
          v-model="listLiData.startTime"
          type="datetime"
          value-format="timestamp"
          placeholder="年/月/日"
        ></el-date-picker>&nbsp;至&nbsp;
        <el-date-picker
          prop="endTime"
          v-model="listLiData.endTime"
          type="datetime"
          value-format="timestamp"
          placeholder="年/月/日"
        ></el-date-picker>
      </div>
      <div style="color:#0096dc;cursor:pointer" @click="addSearchCondition()">+添加条件</div>
    </div>
    <div>
      <search-condition
        @deleteListData="deleteListData"
        v-for="(item,index) in listLiData.gameRankConditionEntities"
        :key="index"
        :searchListData="item"
      ></search-condition>
    </div>

    <div class="border" style="border-bottom:none">
      可获得
      <el-input style="width:100px" v-model="listLiData.count"></el-input>次游戏机会
      <el-checkbox v-model="listLiData.repeat" :true-label=1 :false-label=0>勾选后此条件组会重复触发(净入金、开仓手数条件适用)</el-checkbox>
    </div>
  </div>
</template>

<script>
import searchCondition from "./searchCondition";
import Url from '@/views/crs/util/url';
export default {
  props: ["listLiData"],
  data() {
    return {
      addNum:0
    };
  },
  components: {
    searchCondition
  },
  methods: {
    addSearchCondition() {
      if(this.listLiData.gameRankConditionEntities!=null) {
        let length = this.listLiData.gameRankConditionEntities.length;
        if (length > 2) {
          this.$message("添加不能超过3条");
          return;
        }
      }else{
        this.listLiData.gameRankConditionEntities=[];
      }
      this.listLiData.gameRankConditionEntities.push({
        type: "3",
        typeValue:"1",
        proTypeValue: [],
        conditionsProductType:[],
        productList: [],
        conditionsValue: [],
       
      });
    },
    deleteListData(idIndex){
      // if( this.listLiData.gameRankConditionEntities.length == 1){
      //   this.$message({
      //     message: '最少存在一个条件',
      //     type: 'warning'
      //   });
      //   return
      // }
      let arrIndex = "";
      if (idIndex.id) {
        for (let i in this.listLiData.gameRankConditionEntities) {
          if (this.listLiData.gameRankConditionEntities[i].id == idIndex.id) {
            arrIndex = i;
          }
        }
      } else {
        for (let i in this.listLiData.gameRankConditionEntities) {
          if (this.listLiData.gameRankConditionEntities[i].index == idIndex.index) {
            arrIndex = i;
          }
        }
      }
      this.listLiData.gameRankConditionEntities.splice(arrIndex, 1);
    },
    delist(index,id){

      this.$confirm('是否删除条件组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //删除条件组
        if(id!=null && id !=='' && id != undefined){
          const url = Url.gameRank.base+"/activity/gameRank/conditionGroupDelete?id=" + id;
          this.$axios.delete(url).then(res => {
            if (res.code != 0) {
              return this.$message.error(res.msg);
            } else {
              this.$message({
                message: "删除条件组成功！",
                type: "success"
              });
              let idIndex = {
                id:id,
                index:index
              }
              this.$emit('deletelist',idIndex)
            }
          });
        }else{
          this.$message({
            message: "删除条件组成功！",
            type: "success"
          });
          let idIndex = {
            id:id,
            index:index
          }
          this.$emit('deletelist',idIndex);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box_wrapper {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 5px 0;
  margin-bottom: 10px;
}

.border {
  border-bottom: 1px solid #ddd;
  padding: 10px;
}
</style>